<template>
    <div>
        <zm-row>
            <zm-input @keyup.enter.native="fetchData" style="width: 300px;margin-right: 10px;" v-model="filter.cmkName">
                <zm-button slot="append" icon="zm-icon-search" @click="fetchData"></zm-button>
            </zm-input>
            <zm-button plain @click="showCreate()" type="primary">Create</zm-button>
        </zm-row>
        <div class="table-container" v-loading="loading">
            <zm-table :data="[{}]" v-if="!list.length" class="header-table">
                <zm-table-column prop="cmkName" label="Cmk Name"></zm-table-column>
                <zm-table-column prop="description" label="Description"></zm-table-column>
                <zm-table-column prop="isScheduleToDelete" label="isScheduleToDelete" width="230px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-dropdown trigger="click" @command="handleCommand">
                            <span class="zm-dropdown-link">
                                isScheduleToDelete<i class="zm-icon-down zm-icon--right"></i>
                            </span>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item :command="null">All</zm-dropdown-item>
                                <zm-dropdown-item :command="true">True</zm-dropdown-item>
                                <zm-dropdown-item :command="false">False</zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isDefault" label="isDefault" width="120px">
                </zm-table-column>
                <zm-table-column width="120px"></zm-table-column>
            </zm-table>
            <zm-table
            :data="list.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)">
                <zm-table-column prop="cmkName" label="Cmk Name"></zm-table-column>
                <zm-table-column prop="description" label="Description"></zm-table-column>
                <zm-table-column prop="isScheduleToDelete" label="isScheduleToDelete" width="230px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-dropdown trigger="click" @command="handleCommand">
                            <span class="zm-dropdown-link">
                                isScheduleToDelete<i class="zm-icon-down zm-icon--right"></i>
                            </span>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item :command="null">All</zm-dropdown-item>
                                <zm-dropdown-item :command="true">True</zm-dropdown-item>
                                <zm-dropdown-item :command="false">False</zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                    <template slot-scope="scope">
                        <i :class="scope.row.isScheduleToDelete ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isDefault" label="isDefault" width="120px">
                    <template slot-scope="scope">
                        <i :class="scope.row.isDefault ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                    </template>
                </zm-table-column>
                <!-- <zm-table-column prop="referenceCmkId" label="referenceCmkId"></zm-table-column> -->
                <zm-table-column width="120px">
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" title="edit cmk" @click="showEdit(scope.row)"></zm-button>
                        <zm-button size="small" type="icon" :icon="scope.row.isScheduleToDelete ? 'zm-icon-move-to-folder' : 'zm-icon-delete'"
                        :title="scope.row.isScheduleToDelete ? 'repair cmk' : 'delete cmk'" @click="deleteCmk(scope.row)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageable.pageSize"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="list.length">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :title="form.id ? 'Edit Cmk' : 'Create Cmk'" :visible.sync="visible">
            <zm-form :model="form" label-position="left" ref="form" :rules="rules" label-width="180px">
                <zm-form-item label="cmkName" prop="cmkName">
                    <zm-input v-model="form.cmkName"></zm-input>
                </zm-form-item>
                <zm-form-item label="description" prop="description">
                    <zm-input v-model="form.description"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listCmk, saveCmk, deleteCmk } from '@/api/index'
export default {
    name: 'cmk',
    props: ['applicationId'],
    data () {
        return {
            loading: false,
            filter: {
                applicationId: '',
                cmkName: null,
                scheduleToDelete: null
            },
            list: [],
            visible: false,
            form: {
                id: '',
                applicationId: '',
                cmkName: '',
                description: '',
                referenceCmkId: null
            },
            pageable: {
                pageSize: 10,
                pageNumber: 1
            },
            rules: {
                cmkName: [
                    { required: true, message: 'please input cmkName', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.filter.applicationId = this.applicationId
        this.fetchData()
    },
    methods: {
        fetchData () {
            this.loading = true
            listCmk(this.filter).then(response => {
                this.list = response.data
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    saveCmk(this.form).then(response => {
                        this.$message.success('Submit success')
                        this.visible = false
                        this.fetchData()
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        showCreate () {
            this.form.id = null
            this.form.applicationId = this.applicationId
            this.form.cmkName = ''
            this.form.description = ''
            this.visible = true
        },
        showEdit (row) {
            this.form.id = row.id
            this.form.applicationId = this.applicationId
            this.form.cmkName = row.cmkName
            this.form.description = row.description
            this.visible = true
        },
        deleteCmk (row) {
            this.$confirm(row.isScheduleToDelete ? 'This will repair the cmk. Continue?' : 'This will delete the cmk. Continue?', 'Warning', {
                confirmButtonText: row.isScheduleToDelete ? 'Repair' : 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteCmk(row.id, this.applicationId).then(response => {
                    this.fetchData()
                    this.$message.success(row.isScheduleToDelete ? 'Repair success' : 'Delete success')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: row.isScheduleToDelete ? 'Repair canceled' : 'Delete canceled'
                })
            })
        },
        handleCommand (command) {
            this.filter.scheduleToDelete = command
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        }
    }
}
</script>
<style>
.header-table.zm-table .zm-scrollbar {
    display: none;
}
</style>
